import { inject, Injectable } from '@angular/core';
import { ServicesService } from '../services/services.service';

@Injectable({
  providedIn: 'root',
})
export class GroupEndpointsService {
  readonly #service = inject(ServicesService);

  public endpoint() {
    return this.#service.groupServices('').replace(/\/$/, '');
  }

  public groups() {
    return this.#service.groupServices(`groups`);
  }

  public guiAsset(asset: string) {
    return this.#service.groupServices(`gui/v2/${asset}`);
  }

  public manifest() {
    return this.guiAsset('manifest.json');
  }

  public users() {
    return this.#service.groupServices('users');
  }

  public subscribe(userId: string) {
    return this.#service.groupServices(`groups/subscriptions/${userId}`);
  }

  public demo(sourceGroupId: string, code: string) {
    return this.#service.groupServices(`groups/${sourceGroupId}/demo/${code}`);
  }

  public cloneDemoData(groupId: string) {
    return this.#service.thor(`group/${groupId}/clone-data-for-demogroup`);
  }
}
